'use strict';
import iziModal from 'iziModal';

export default class Form {
    constructor() {
        $(document).ready(function () {




            $('textarea')
                .on('focus', function () {
                    let colorBorder = $(this).css('color');
                    $(this).parents('[data-sf-role="paragraph-text-field-container"]').css('border-color', colorBorder);
                });
            $('textarea')
                .on('blur', function () {
                    $(this).parents('[data-sf-role="paragraph-text-field-container"]').css('border-color', '');
                });

            //checkboxes and radio Buttons
            $('input[type="checkbox"]').each(function (i, ele) {
                let parent = $(this).parents('.sf-fieldWrp label,.form-group label');

                parent.append('<div class="checkbox-indicator"></div>');
                // $(this).remove();
            });

            $('input[type="radio"]').each(function (i, ele) {
                let parent = $(this).parents('.sf-fieldWrp label,.form-group label');

                parent.append('<div class="radio-indicator"></div>');
                // $(this).remove();
            });


            if (!$('#store-map').length) {
                $('select').niceSelect();
            }
            let thankyouModal = $('.modal-thankyou').iziModal({
                headerColor: '#26A69A',
                width: '50%',
                overlayColor: 'rgba(0, 0, 0, 0.7)',
                fullscreen: true,
                width: '80%',
                transitionIn: 'fadeInUp',
                transitionOut: 'fadeOutDown',
                overlayClose: false,
            });

            window.globalModelThankYou = thankyouModal;

            window.globalClearFormFields = function () {
                $('input[type=checkbox],input[type=radio]').prop('checked', false);
                $('select').each(function (i, ele) {
                    $(ele).val($(ele).find('option:first').val());
                });
                $('select').niceSelect('update');
                $('.floating').removeClass('focus');
            };

            window.scrollToErrorMessage = function (form) {
                TweenMax.to(window, 1, {
                    scrollTo: {
                        y: form,
                        autoKill: false,
                        offsetY: 110
                    },
                    ease: Power2.easeInOut
                });
            };



            $('.form-group textarea.form-control , .sf-fieldWrp textarea.form-control,.form-group select.form-control , .sf-fieldWrp select.form-control ').each(function (i, ele) {

                if ($(ele).prop('required')) {
                    $(ele).siblings('label').addClass('mandatory');
                }
            });

            $('.form-group input[type="checkbox"] , .sf-fieldWrp input[type="checkbox"],.form-group input[type="radio"] , .sf-fieldWrp input[type="radio"] ').each(function (i, ele) {
                if ($(ele).prop('required')) {
                    $(ele).parents('[data-sf-role="checkboxes-field-container"], [data-sf-role="multiple-choice-field-container"]').find('strong').addClass('mandatory');
                }
            });




        });

    }
}
